import styled from 'styled-components';
import {Input, Form, Button} from 'global/styles/styles.js';

const S = {};

S.ForgotPasswordForm = styled(Form)` 
    display: flex;
    flex-direction: column;
    padding: 0 1rem 1rem;
    background-color: #fff;
`;

S.Row = styled.div`
    width: 100%;
`;

S.InputWrapper = styled.div`
    position: relative;
    padding: 0.625rem 0 0 0;
    width: 100%; 
    margin: 0 auto;
`;

S.Input = styled(Input)`
    border: 1px solid ${({theme: {$forgotPasswordInputBorderColor}}) => $forgotPasswordInputBorderColor};
    border-radius: 3px;
    background-color: #fff;
    height: 42px;
    color: #000;
    font-size: 0.875rem;
    box-sizing: border-box;
    width: 100%;
    padding: 0px 1.33333rem;

    &:valid {
        & + label {
        color: rgba(0, 0, 0, 0.5);
        margin-top: -1.3125rem;
        font-size: 0.625rem;
        }
    }

    &:focus {
        outline: 0;
    }
`;

S.SubmitButton = styled(Button)`
    background-color: ${({theme: {$forgotPasswordButtonBgColor}}) => $forgotPasswordButtonBgColor}
    color: #fff;
    border-radius: 3px;
    height: 2.625rem;
    margin-top: 1.6rem;
    &[disabled] {
        background: #eee;
        color: #676767;
    }
`;

S.Error = styled.div`
    color: #D32F2F;
    font-size: 10px;
`;

S.Info = styled.p`
    font-size: 12px;
    color: #777d85;
`;

S.SubmissionError = styled.div``;

S.Label = styled.label`
    position: absolute;
    pointer-events: none;
    color: rgba(0, 0, 0, 54%);
    text-align: left;
    left: 10px;
    top: 24px;
    background-color: ${({theme: {$forgotPasswordLabelBgColor}}) => $forgotPasswordLabelBgColor};
    width: auto;
    font-size: 0.75rem;
    padding: 0 0.5rem;
    font-weight: 500;
    transition: .2s;
`;

S.SuccessModal = styled.div`
    padding: 0 1rem 1rem;
`;

S.SuccessTitle = styled.h4`
    color: #2d9ef5;
    font-size: 1.83rem;
    font-weight: 700;
    margin: 1.5rem;
    padding: 0;
`;

S.SuccessMsg = styled.p`
    text-align: center;
    color: #000;
    margin: 0;
    font-size: 1.15rem;
`;

S.SubmissionSuccess = styled.p`
    border-radius: 0.25rem;
    width: calc(100%-1rem);
    text-align: left;
    padding: .5rem;
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
    font-size: 12px;
`;

export default S;
